import { create } from "zustand";

type CampaignStore = {
  mediaProductSelected: string[];
  openCampaignDialog: boolean;
  setOpenCampaignDialog: (value: boolean, mediaProductSelected?: string[]) => void;
  setMediaProductSelected: (values: string[]) => void;
};

export const useCampaignStore = create<CampaignStore>((set) => ({
  mediaProductSelected: [],
  openCampaignDialog: false,
  setOpenCampaignDialog: (value, mediaProductSelected = []) => {
    set({ openCampaignDialog: value, mediaProductSelected});
  },
  setMediaProductSelected: (values) => {
    set({ mediaProductSelected: values });
  },
}));
